// to use this add <script type="text/javascript" src="https://js.openpay.mx/openpay.v1.min.js" />
import { useState, useEffect } from 'react';

export default function useOpenPay() {
  const [deviceSessionId, setDeviceSessionId] = useState();

  useEffect(() => {
    try {
      if (OpenPay) {
        OpenPay.setId(process.env.NEXT_PUBLIC_MERCHANT_ID);
        OpenPay.setApiKey(process.env.NEXT_PUBLIC_PUBLIC_API_KEY);
        if (process.env.NEXT_PUBLIC_OPENPAY_MODE === 'develop') {
          OpenPay.setDevelopMode(true);
          console.log('OpenPay Mode: develop');
        } else if (process.env.NEXT_PUBLIC_OPENPAY_MODE === 'sandbox') {
          OpenPay.setSandboxMode(true);
          console.log('OpenPay Mode: sandbox');
        } else {
          console.log('OpenPay Mode: production');
        }
      }
    } catch {
      console.log('OpenPay Mode: production');
    }
  }, []);

  useEffect(() => {
    try {
      if (OpenPay) {
        setDeviceSessionId(OpenPay.deviceData.setup());
      }
    } catch {
      console.log('OpenPay Mode: production');
    }
  }, [setDeviceSessionId]);

  const validateCard = ({ creditCard, validity, cvv }) => {
    if (OpenPay) {
      const expiration_year = validity.substring(2, 4);
      const expiration_month = validity.substring(0, 2);
      if (!OpenPay.card.validateCardNumber(creditCard)) {
        return { error: 'Número de tarjeta no válido: ' + creditCard };
      }
      if (!OpenPay.card.validateCVC(cvv, creditCard)) {
        return { error: 'CVV inválido' };
      }
      if (
        !OpenPay.card.validateExpiry(expiration_month, `20${expiration_year}`)
      ) {
        return { error: 'Fecha de expiración inválida' };
      }
    }
    return false;
  };

  const createToken = ({ creditCard, validity, cvv, name }) =>
    new Promise((resolve, reject) => {
      if (OpenPay) {
        const validation = validateCard({ creditCard, validity, cvv });
        if (validation) {
          reject(validation);
          return;
        }

        const expiration_year = validity.substring(2, 4);
        const expiration_month = validity.substring(0, 2);

        OpenPay.token.create(
          {
            card_number: creditCard,
            holder_name: name,
            expiration_year,
            expiration_month,
            cvv2: cvv,
          },
          (resp) => {
            if (resp.status === 200) {
              resolve(resp.data);
            } else {
              console.log('Token error:', resp);
              reject({ error: resp.data.description });
            }
          },
          (err) => {
            console.log('Token error:', err);
            reject({ error: err.data.description });
          },
        );
      } else {
        reject({ error: 'No OpenPay library' });
      }
    });

  return {
    createToken,
    validateCard,
    deviceSessionId,
  };
}
